<template>
  <div class="headerContent">
    <div class="leftArea" @click="goBackFun()">
      <i class="icon iconfonticon iconfont icon-xiangzuo" />
      <span>{{
        detailName ? detailName : $route.query.name ? $route.query.name : ""
      }}</span>
    </div>

    <!-- 工具栏 -->
    <div class="rightArea" v-if="!onlyBlackShow">
      <!-- 用户数据显示 -->
      <div class="userArea">
        <el-popover
          placement="bottom-start"
          popper-class="userPopover"
          width="90"
          trigger="click"
          style="top: 35px !important"
        >
          <!-- 前台工具栏 -->
          <div class="popoverArea" v-if="typeShow === 1">
            <p @click="$router.push({ path: '/personalCenter' })">账号管理</p>
            <p
              @click="$openAdmin({ path: '/cust/main/adminMain' })"
              v-if="sysUserMsg && sysUserMsg.isadmin < 3"
            >
              后台管理
            </p>
            <!-- <p
              @click="
                $router.push({ path: '/clientSide/setUpThe/changePassword' })
              "
            >
              修改密码
            </p> -->
            <p @click="logout">退出账号</p>
          </div>
          <!-- 后台工具栏 -->
          <div class="popoverArea" v-if="typeShow === 2">
            <!-- <p @click="$router.push({ path: '/personalCenter' })">我的档案</p>
            <p
              @click="
                $router.push({ path: '/clientSide/setUpThe/changePassword' })
              "
            >
              设置
            </p> -->
            <p @click="$router.push({ path: '/index' })">客户端查看</p>
            <p @click="logout">退出登录</p>
          </div>
          <!-- 点击切换 -->
          <template #reference>
            <div style="cursor: pointer">
              <i
                v-if="
                  userMsg && userMsg.sex !== null && userMsg.sex !== undefined
                "
                :class="
                  userMsg.sex === 0
                    ? 'iconfont icon-morenyonghutouxiang man'
                    : 'iconfont icon-morenyonghutouxiang'
                "
              ></i>
              <div class="name">{{ sysUserMsg.name }}</div>
            </div>
          </template>
          
        </el-popover>
      </div>
      <!-- 通知 -->
      <div class="remind" style="position: relative">
        <schoolNews />
      </div>
      <!-- 跳转按钮 -->
      <div
        class="spheric-button"
        @click="onpermission"
        v-if="ispermission && $route.query.categoryId"
      >
        <i class="icon iconfonticon iconfont" :class="iconCls" v-if="iconCls" />
        进入应用管理
      </div>
    </div>

    <!-- 分组锁 -->
    <group-lock
      :info="groupLockInfo"
      v-model="isShowGroupLock"
      @unLock="unLock"
    ></group-lock>
  </div>
</template>

<script>
import { axiosBase } from "@/api/api";
import schoolNews from '@/components/common/schoolNews.vue'
import { getoutcustomdeskkey, getregisterusertemplate } from '@/port/schoolInstrument/appConfig.js'
import { signOut, xmssOut } from '@/api/utils'
import { defineAsyncComponent } from "vue";
export default {
  name: "oaFrameNav",
  props: {
    perviousUrl: {
      default: 1
    },
    isAdmin: {
      default: true
    },
    //- 是否只是展示返回按钮
    onlyBlackShow: {
      type: Boolean,
      default: false
    },
    //- 记录当嵌入组件nav点击回调后页面返回卡顿时需要直接返回的页面
    backUrl: {
      type: String,
      default: ''
    },
    //- 当前导航栏展示模式：1：前台，2：后台
    typeShow: {
      type: Number,
      default: 1
    },
    //- 跳转按钮icon图标
    iconCls: {
      type: String,
      default: '',
    },
    // 明细的名称
    detailName: {
      type: String,
      default: ''
    },
    // 官网的开关
    websiteSwitch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      //- 用户数据
      sysUserMsg: '',
      //- 学校信息
      userMsg: null,
      sysUserAvatar: "",
      isNewsCount: '',
      ispermission: false,
      groupLockInfo: {}, // 分组锁的info
      isShowGroupLock: false,
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
    }
  },
  components: {
    schoolNews,
    GroupLock: defineAsyncComponent(() => import('@/components/clientSide/common/groupLock.vue'))
  },
  created () {
    // if (this.onlyBlackShow) {
    //   return false
    // }
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
    let user = localStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      this.sysUserMsg = user || "";
      this.sysUserAvatar = user.name.substr(0, 1) || "";
    }
    //- 获取学校缓存消息
    let userMsg = localStorage.getItem("userMsg");
    if (userMsg) {
      this.userMsg = JSON.parse(userMsg);
    }
    /***
     * 以下判断是否显示进入应用管理，
     * 为了不每次进来都走接口，做了缓存
     * 如果显示就为2不显示为1，后面渲染成true或false对应2和1
     */
    let ispermission = sessionStorage.getItem('ispermission')
    if (ispermission) {
      if (ispermission == '2') {
        this.ispermission = true;
      } else {
        this.ispermission = false;
      }
    } else {
      // 官网不显示工具栏 所以不要请求这个接口
      if (this.websiteSwitch) return false
      axiosBase({}, "/openapi/ispermission").then(res => {
        if (res.code === 0) {
          this.ispermission = res.data;
          if (res.data) {
            sessionStorage.setItem('ispermission', '2')
          } else {
            sessionStorage.setItem('ispermission', '1')
          }
        }
      });
    }
  },
  methods: {
    goBackFun () {
      console.log("路由监听1", this.perviousUrl)
      console.log("路由监听2", this.$route)
      if (this.$route.query.from && this.$route.query.from == 'admin') {
        let spaceId = localStorage.getItem('spaceid');
        let upaceId = localStorage.getItem('upaceid');
        if(this.isSpace && typeof(spaceId) !== 'undefined'){
          this.$router.push({ path: '/space/oaExamine?spaceid=' + spaceId });
        }
        else if(this.isUpace && typeof(upaceId) !== 'undefined'){
          this.$router.push({ path: '/upace/oaExamine?upaceid=' + upaceId });
        }
        else{
          this.$router.push({ path: '/clientSide/oaExamine' });
        }
        this.$store.commit('changeSelect', 4);
      } else {
        if (this.websiteSwitch) {
          // 由官网的外链跳转进来
          const skey = localStorage.getItem('skey')
          const url = this.$url + '/website/' + skey
          // 本地测试跳转
          // const url = 'http://localhost:8081/website/'+skey
          window.location.href = url
          return
        }
        if (this.$route.query.url) {
          // 由外链跳转进来
          this.$router.replace({ path: '/index' })
        }
        if (this.backUrl != '') {
          if (this.$route.query.applyCenter) {
            this.$router.go(-1)
          } else {
            this.$router.push({
              path: this.backUrl
            })
          }
        } else {
          this.$router.go(-this.perviousUrl)
        }

        // window.history.go(-1)
      }
    },
    logout () {
      const _this = this
      this.$confirm("确认退出吗?", {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async() => {
          let userMsg = localStorage.getItem("userMsg");
          userMsg = JSON.parse(userMsg);
          const schoolId = userMsg.schoolMsg.schoolId
          const obj = { schoolId }
          if (this.spaceid || this.$route.query.spaceid) {
            obj.spaceid = this.spaceid || this.$route.query.spaceid
          }
          const res = await getoutcustomdeskkey(obj)
          if (res.code === 0) { 
            const skey = res.data
            if (skey) {
              const res1 = await getregisterusertemplate({skey})
              if (res1.code === 0) {
                signOut()
                  .then(() => {
                    if(this.$apiurl === 'https://xm.sszx.cn'){
                      xmssOut()
                    }
                    // else{
                    //   url = this.$router.push(`/website/${skey}`)
                    // }
                  })
                  .catch(error => {
                    console.error("登出失败：", error);
                  });
              } else {
                if (userMsg.ixmssoSessionId) {
                //- 说明是i厦门登录，退出需要走接口
                  _this.signLoginOut(userMsg.ixmssoSessionId);
                } else {
                  signOut()
                    .then(() => {
                      if(_this.$apiurl === 'https://xm.sszx.cn'){
                        xmssOut()
                      }
                      else{
                        _this.$router.push("/");
                      }
                    })
                    .catch(error => {
                      console.error("登出失败：", error);
                    });
                }
              }
            } else {
              if (userMsg.ixmssoSessionId) {
                //- 说明是i厦门登录，退出需要走接口
                _this.signLoginOut(userMsg.ixmssoSessionId);
              } else {
                signOut()
                  .then(() => {
                    if(_this.$apiurl === 'https://xm.sszx.cn'){
                      xmssOut()
                    }
                    else{
                      _this.$router.push("/");
                    }
                  })
                  .catch(error => {
                    console.error("登出失败：", error);
                  });
              }
            }
          }
        })
        .catch(() => { });
    },
    unLock () {
      if(this.isSpace){
          const spaceId = this.$route.query.spaceid
          if (typeof(spaceId) !== 'undefined'){
            localStorage.setItem('spaceid',spaceId);
          }
          this.$openAdmin({ path: '/cust/main/admins/workbench/appliedManagementlist?space=true&categoryId=' + this.$route.query.categoryId + '&names=' + this.$route.query.name })
        } else if(this.isUpace){
          const upaceId = this.$route.query.upaceid
          if (typeof(upaceId) !== 'undefined'){
            localStorage.setItem('upaceid',upaceId);
          }
          this.$openAdmin({ path: '/cust/main/admins/workbench/appliedManagementlist?upace=true&categoryId=' + this.$route.query.categoryId + '&names=' + this.$route.query.name })
        } else{
          this.$openAdmin({ path: '/cust/main/admins/workbench/appliedManagementlist?categoryId=' + this.$route.query.categoryId + '&names=' + this.$route.query.name })
        }
    },
    async onpermission () {
      // 判断有没有分组锁
      const res = await axiosBase({
        categoryId: this.$route.query.categoryId
      }, '/api/getapprovalcategorylockstatus')

      if (res.data === 1) {
        const obj = {
          categoryId: this.$route.query.categoryId,
          lockstatus: res.data,
          verify: true
        }
        this.groupLockInfo = obj
        this.isShowGroupLock = true
      } else {
        if(this.isSpace){
          const spaceId = this.$route.query.spaceid
          if (typeof(spaceId) !== 'undefined'){
            localStorage.setItem('spaceid',spaceId);
          }
          this.$openAdmin({ path: '/cust/main/admins/workbench/appliedManagementlist?space=true&categoryId=' + this.$route.query.categoryId + '&names=' + this.$route.query.name })
        }
        else if(this.isUpace){
          const upaceId = this.$route.query.upaceid
          if (typeof(upaceId) !== 'undefined'){
            localStorage.setItem('upaceid',upaceId);
          }
          this.$openAdmin({ path: '/cust/main/admins/workbench/appliedManagementlist?upace=true&categoryId=' + this.$route.query.categoryId + '&names=' + this.$route.query.name })
        }
        else{
          this.$openAdmin({ path: '/cust/main/admins/workbench/appliedManagementlist?categoryId=' + this.$route.query.categoryId + '&names=' + this.$route.query.name })
        }        
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/schoolMainInstrument.scss";
.headerContent {
  width: 97.9%;
  padding: 0 1%;
  position: relative;
  display: inline-block;
  height: 60px;
  line-height: 60px;
  background: white;
  .leftArea {
    float: left;
    height: 100%;
    color: #333333;
    cursor: pointer;
    i {
      display: inline-block;
      font-size: 17px;
      margin-right: 5px;
    }
    span {
      display: inline-block;
      vertical-align: top;
    }
  }

  .rightArea {
    float: right;
    width: 33%;
    .spheric-button {
      float: right;
      color: #4e86ff;
      background: #f1f8ff;
      border-radius: 17px;
      border: 1px solid #4e86ff;
      padding: 2px 20px;
      margin-top: 16px;
      height: 22px;
      line-height: 21px;
      font-size: 12px;
      cursor: pointer;
      i {
        display: inline-block;
        font-size: 12px;
      }
    }
    .inputArea {
      width: 52%;
      float: right;
      :deep(.el-input__inner) {
        background-color: #f2f2f2;
        border-radius: 23px;
        border: none;
        padding-left: 57px;
        height: 32px;
        line-height: 32px;
      }
      :deep(.el-input__prefix) {
        left: 31px;
      }
    }
    .remind {
      vertical-align: top;
      float: right;
      /*margin: 0 3% 0 7%;*/
      i {
        font-size: 33px;
      }
    }
    .userArea {
      vertical-align: top;
      max-width: 80%;
      margin-top: 3px;
      float: right;
      .avatar {
        display: inline-block;
        margin-top: 4px;
      }
      i {
        display: inline-block;
        font-size: 32px;
        color: #fd8c88;
        margin: -3px 0;
        &.man {
          color: #71b7fd;
        }
      }
      .name {
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        text-align: center;
        height: 60px;
        line-height: 57px;
      }
    }
  }
}
// .oa-frame-nav {
//   height: 43px;
//   width: calc(100% - 60px);
//   line-height: 43px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   background: $base-borderHover-color;
//   padding-left: 20px;
//   padding-right: 40px;
// }
// .nav-right {
//   display: flex;
//   align-items: center;
// }
// .spheric-button {
//   border-radius: 15px !important;
//   @include base-two-button-center;
//   &.is-plain {
//     border: none;
//   }
// }
// .icon-left {
//   font-size: 14px;
//   font-weight: bold;
// }
// .ret-button {
//   margin-right: 20px;
// }
// .nav-name {
//   font-size: 14px;
//   color: #333333;
// }
// .nav-name-center {
//   font-size: 14px;
//   color: #333333;
//   text-align: center;
// }
// .spheric-title {
//   width: 30px;
//   height: 30px;
//   line-height: 30px;
//   text-align: center;
//   background: #ffffff;
//   margin-right: 11px;
//   -webkit-border-radius: 50%;
//   -moz-border-radius: 50%;
//   border-radius: 50%;
// }
// .user-name,
// .spheric-title {
//   font-size: 14px;
//   color: #333333;
// }
</style>
